var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.Mensaje))])}
var staticRenderFns = []

export { render, staticRenderFns }